import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import LocalStorageHelper from '../storage/LocalStorageHelper';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
const SESSION_TOKEN='sessionToken';
export default class SessionManager{
	static get instance(){
		if(!SessionManager._instance)
			SessionManager._instance = new SessionManager();
		return SessionManager._instance;
	}
	constructor(){
		this._sessionToken = LocalStorageHelper.getObj(SESSION_TOKEN);
	}
	set sessionToken(value){
		this._sessionToken = value;
		LocalStorageHelper.setObj(SESSION_TOKEN, value);
	}
	get sessionToken(){
		return this._sessionToken;
	}
	get sessionTokenIsValid(){
		return this._sessionToken!==undefined&&this._sessionToken!==null&&this._sessionToken!=='';
	}
	clearSessionToken(){
		this.sessionToken = null;
	}
}